export default "__VITE_ASSET__viSY9WVC__"